export default __webpack_public_path__ + "static/media/shayan.44f0c5b8.jpg";